import React, { useEffect, useState } from "react";
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Link } from "react-router-dom";

import LandingHeader from "../../Components/Landing/LandingHeader";
import LandingFooter from "../../Components/Landing/LandingFooter";

import PhotoBookImg from "../../assets/img/photobook.jpg";
import CanvasImg from "../../assets/img/canvas-img.jpg";
import UserIcon from "../../assets/img/user-icon.svg";
import ProjectIcon from "../../assets/img/project-icon.svg";
import OrderIcon from "../../assets/img/order-icon.svg";
import SettingIcon from "../../assets/img/setting-icon.svg";
import LockIcon from "../../assets/img/lock-icon.svg";
import MyOrderService, { Order } from "../../Services/MyOrderService";
import { toast } from "react-toastify";
import ConfirmModal from "./ConfirmModal";
import loadingSpinner from '../../assets/img/Spinner.svg';
import shippingStore from "../../stores/ShippingStore";
import { useNavigate } from 'react-router-dom';

interface MergedOrderDetail {
    orderID: number;
    orderDate: string;
    orderStatus: string;
    quantity: number;
    price: number;
    productType: string;
    productName: string;
    productDesc: string;
    allOrders: number;
    inprogress: number;
    delivered: number;
    projectImageUrl: string;
    width: number;
    height: number;
  }
function MyOrders() {
    const [orders, setOrders] = useState<Order[]>([]);
    const [filteredOrders, setFilteredOrders] = useState<Order[]>([]);
    const [filter, setFilter] = useState<string>('all'); 
    const [orderToDelete, setOrderToDelete] = useState<{ orderId: number} | null>(null); 
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [orderList, setOrderList] = useState<MergedOrderDetail[]>([]);
    const [loading, setLoading] = useState(true);
    const [allCount, setAllCount] = useState(0);
    const [inProgressCount, setInProgressCount] = useState(0);
    const [deliveredCount, setDeliveredCount] = useState(0);
    const navigate = useNavigate();
    


    useEffect(() => {
        fetchOrders("all"); 
      }, []);

        const fetchOrders = async (status: string) => {
            setLoading(true); 
            try {
                const orderData = await MyOrderService.GetMyOrders(status); 
                const mergedOrderDetails: MergedOrderDetail[] = orderData.flatMap(order =>
                    order.orderDetailsList.map(orderDetail => ({
                      orderID: order.orderID,
                      orderDate: order.orderDate,
                      orderStatus: order.orderStatus,
                      quantity: orderDetail.quantity,
                      price: orderDetail.price,
                      productType: orderDetail.productType,
                      productName: orderDetail.productName,
                      productDesc: orderDetail.productDesc,
                      allOrders: order.ordersCountSummary.allOrders,
                      inprogress: order.ordersCountSummary.inprogress,
                      delivered: order.ordersCountSummary.delivered,
                      projectImageUrl:orderDetail.projectImageUrl,
                      width: orderDetail.width,
                      height: orderDetail.height,
                    }))
                  );
                  if (orderData.length > 0) {
                    const summary = orderData[0].ordersCountSummary;
                    setAllCount(summary.allOrders);
                    setInProgressCount(summary.inprogress);
                    setDeliveredCount(summary.delivered);
                }
                  setOrderList(mergedOrderDetails);
                setOrders(orderData);
                setFilteredOrders(orderData);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false); 
            }
           
        };
    
    const handleFilterChange = async(type: string) => {
        setFilter(type);
        fetchOrders(type);
    };


    const confirmDeleteProject = (orderId: number) => {
        setOrderToDelete({ orderId: orderId });
        setShowConfirmModal(true);
    };

    const DeleteOrder = async () => {
        if (!orderToDelete) return;
    
        try {
            const res = await MyOrderService.DeleteOrder(orderToDelete.orderId);
            console.log(res);
    
            if (res?.status === 200) {
                toast.success(res?.data?.data, { position: 'top-center' });
                setTimeout(async () => {
                    const updatedOrders = await MyOrderService.GetMyOrders("all");
                    setOrders(updatedOrders);
                }, 1000);
            } else if (res?.status === 400) {
                toast.error("Order still in progress cannot delete");
            }
        } catch (error: any) {
            toast.error('An error occurred during delete order', { position: 'top-right' });
        } finally {
            setShowConfirmModal(false); 
        }
    };

    const reorderProduct = async (orderId: number) =>{
        try {
            const res = await MyOrderService.ReorderProduct(orderId);
            console.log(res);
            
            if (typeof res === "string") {
                toast.error(res, { position: 'top-center' });
            } else {
                if (res.status === 200) {
                    toast.success(res.data.message, { position: 'top-center' });
                    const data = await MyOrderService.GetShippingDetails(orderId);
                    if(data){
                        const requestBody = {
                            specialInstructions: "",
                            shippingDetails: {
                              firstName: data.firstName,
                              lastName: data.lastName,
                              phoneNo: data.phoneNo,
                              shippingAddress: data.shippingAddress,
                              country: data.country,
                              state: data.state,
                              city: data.city,
                              zipCode: data.zipCode,
                              shippingMethod: "",
                            },
                          };
                          shippingStore.updateField(requestBody);
                          setTimeout(() => {
                            navigate(`/yourcart`, { replace: true });
                          },1000);
                    }
                } else if (res.status === 400) {
                    toast.error("Failed to reorder your product");
                }
            }
            
        } catch (error: any) {
            toast.error('An error occurred during re-order the product', { position: 'top-right' });
        } finally {
        }
        
    }
    

    return (
        <div className="flex min-h-screen flex-col font-jakarta text-ink antialiased">
            <LandingHeader />
           
            <div> 
                {/* <button onClick={() => setShowModal(true)}
                    type="button"
                    className="rounded-full text-slate-900 hover:bg-gray-200 p-2 mt-1">
                    <TrashIcon aria-hidden="true" className="h-5 w-5" />
                </button> */}
            </div>

            <section className="MyAccounts login-bg flex-1 pt-6 pb-10">
                <div className="mx-auto max-w-7xl">
                    <div className="grid grid-cols-1 text-2xl font-semibold text-left pb-6"> My Accounts </div>
                    <div className="flex flex-row">
                        <div className="basis-3/12">
                            <div className="mr-10">
                                <ul className="list-none bg-white border border-gray-200 rounded-lg shadow p-5">
                                    {/* <li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={UserIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">My Profile</span>
                                        </button>
                                    </li> */}
                                    <li className="pb-2">
                                        <Link to="/MyAccounts" className="hover:underline flex text-sm text-inherit">
                                            <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                                <img src={ProjectIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                                <span className="ml-3">My Projects</span>
                                            </button>
                                        </Link>
                                    </li>
                                    <li className="pb-2">
                                        <Link to="/Orders" className="hover:underline flex text-sm text-inherit">
                                            <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md bg-brand-soft text-brand">
                                                <img src={OrderIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                                <span className="ml-3">My Orders</span>
                                            </button>
                                        </Link>
                                    </li>
                                     <li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={SettingIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">Account & Settings</span>
                                        </button>
                                    </li>
                                    {/*<li className="pb-2">
                                        <button className="flex font-medium text-base pt-3 pl-5 pb-3 w-full rounded-md">
                                            <img src={LockIcon} alt="Xceedprintsolutions" className='h-full w-auto' />
                                            <span className="ml-3">Password</span>
                                        </button>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="basis-9/12">
                            <div className="flex flex-row">
                                <div className="basis-6/12"> 
                                    <div className="text-2xl font-normal text-left">My Orders</div>
                                </div>
                                <div className="basis-6/12">
                                <div className="text-right text-sm text-gray-800">
                                        Category:
                                        <button
                                            className={`rounded-full p-1 pl-3 pr-3 mr-3 ml-3 ${filter === 'all' ? 'bg-brand text-white' : 'bg-white'}`}
                                            onClick={() => handleFilterChange('all')}
                                        >
                                            All ({allCount})
                                        </button>
                                        <button
                                            className={`rounded-full p-1 pl-3 pr-3 mr-3 ${filter === 'delivered' ? 'bg-brand text-white' : 'bg-white'}`}
                                            onClick={() => handleFilterChange('delivered')}
                                        >
                                            Delivered ({deliveredCount})
                                        </button>
                                        <button
                                            className={`rounded-full p-1 pl-3 pr-3 ${filter === 'inprogress' ? 'bg-brand text-white' : 'bg-white'}`}
                                            onClick={() => handleFilterChange('inprogress')}
                                        >
                                            In Progress ({inProgressCount})
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {loading ? (
                                <div className="text-center my-8">
                                    <img src={loadingSpinner} alt="Loading..." className="mx-auto h-16 w-16" />
                                </div>
                            ) : (
                                <>
                                    {/* If no orders found */}
                                    {orderList.length === 0 ? (
                                        <div className="text-center text-gray-600 text-lg mt-8">
                                            No records found
                                        </div>
                                    ) : (
                                        <div className="grid-cols-1">
                                            {orderList.map((order, index) => (
                                                <div key={`${order.orderID}-${index}`} className="flow-root bg-white border border-gray-200 rounded-lg shadow p-5 my-3">
                                                    <ul role="list" className="-my-6 divide-y divide-gray-200">
                                                        <li className="flex py-6">
                                                        <div
                                                            className="flex-shrink-0 overflow-hidden rounded-md border border-gray-200"
                                                            style={{ width: "152px", height: "98px" }} 
                                                        >
                                                            <img
                                                                src={
                                                                    order.productType?.toLowerCase() === "photobook"
                                                                        ? PhotoBookImg
                                                                        : order?.projectImageUrl ?? "fallbackImageURL"
                                                                }
                                                                alt="Xceedprintsolutions"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "contain", 
                                                                    backgroundColor: "#f0f0f0", 
                                                                }}
                                                                className="rounded-md"
                                                            />
                                                        </div>
                                                            <div className="ml-4 flex flex-1 flex-col">
                                                                <div className="flex justify-between text-base font-normal text-gray-900">
                                                                    <div className="text-xl font-medium text-gray-900 mt-1">
                                                                        <div className="mt-1 text-sm text-gray-500"> Order # {order.orderID} </div>
                                                                        {order.productType.charAt(0).toUpperCase() + order.productType.slice(1)}
                                                                        <span className="text-base text-gray-700"> {order.productName || "Unnamed Product"}</span>
                                                                        <p className="mt-1 text-sm text-gray-500"> Size: {order.width} X {order.height} {order.productType === "Canvas" ? "Wrapped canvas (1.5 depth)": ""} </p>
                                                                        <p className="mt-1 text-sm text-gray-500"> Status: {order.orderStatus} </p>
                                                                    </div>
                                                                    <span className="text-xl font-medium text-gray-900 mt-7">${order.price.toFixed(2)}</span>
                                                                    <button
                                                                        type="button" onClick={() => reorderProduct(order.orderID)}
                                                                        className="mt-5 inline-flex h-10 items-center rounded-full border-2 border-brand px-3 py-2 text-xs font-semibold text-brand hover:bg-brand hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand">
                                                                        Order Again
                                                                    </button>
                                                                    {/* {!(order.orderStatus === 'Pending' || order.orderStatus === 'In Progress' || order.orderStatus === 'Confirmed') && (
                                                                        <button
                                                                            type="button" onClick={() => confirmDeleteProject(order.orderID)}
                                                                            className="rounded-full text-slate-900 hover:bg-gray-200 p-2 mt-1">
                                                                            <TrashIcon aria-hidden="true" className="h-5 w-5" />
                                                                        </button>
                                                                    )} */}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </section>
            <LandingFooter />
            <ConfirmModal
                show={showConfirmModal}
                message="Are you sure you want to delete this order?"
                onConfirm={DeleteOrder}
                onCancel={() => setShowConfirmModal(false)}
            />
        </div>
    );
}

export default MyOrders;
